import axios from "axios";
import Qs from "qs";
import Vue from "vue";
import { Notify } from "vant";

Vue.use(Notify);

// 携带cookie
axios.defaults.withCredentials = true; //等同于在封装的实例里面设置

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000, // 请求超时时间
  transformRequest: [
    function(data) {
      // formData格式不做转换
      if (data instanceof FormData) {
        return data;
      }
      //在请求发送到服务器之前让DATA以键值对形式传参数
      data = Qs.stringify(data);
      return data;
    }
  ],
  // 自定义headers
  headers: { "Content-Type": "application/x-www-form-urlencoded" }, //自定义请求头信息
  withCredentials: true
});

//(添加请求拦截器)
// request拦截器
service.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

//返回状态判断(添加响应拦截器)
// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    return response;
  },
  error => {
    console.log("err", error); // for debug
    Notify({
      message: "请求超时",
      duration: 5000
    });
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js